(() => {
  const motion = window.MioAboutMotion;

  if (motion && typeof motion.teardown === 'function') {
    motion.teardown();
  }

  const observers = new WeakMap();
  const revealSelector = '.mio-about-reveal';
  const pageSelector = '.mio-about';

  const revealAll = (page) => {
    page.classList.remove('is-motion-ready');
    page.querySelectorAll(revealSelector).forEach((item) => {
      item.classList.add('is-visible');
      item.style.removeProperty('--mio-about-reveal-delay');
    });
  };

  const disconnect = (page) => {
    const observer = observers.get(page);

    if (observer) {
      observer.disconnect();
      observers.delete(page);
    }

    page.removeAttribute('data-mio-about-motion');
  };

  const initPage = (page) => {
    if (!page || page.dataset.mioAboutMotion === 'ready') return;

    const revealItems = Array.from(page.querySelectorAll(revealSelector));
    const prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    page.dataset.mioAboutMotion = 'ready';

    if (!revealItems.length || prefersReducedMotion || !('IntersectionObserver' in window)) {
      revealAll(page);
      return;
    }

    page.classList.add('is-motion-ready');

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (!entry.isIntersecting) return;

          entry.target.classList.add('is-visible');
          observer.unobserve(entry.target);
        });
      },
      {
        rootMargin: '0px 0px -8% 0px',
        threshold: 0.18,
      }
    );

    revealItems.forEach((item, index) => {
      item.style.setProperty('--mio-about-reveal-delay', `${Math.min(index * 90, 240)}ms`);
      observer.observe(item);
    });

    observers.set(page, observer);
  };

  const init = (root = document) => {
    const pages = root.matches && root.matches(pageSelector) ? [root] : Array.from(root.querySelectorAll(pageSelector));
    pages.forEach(initPage);
  };

  const cleanup = (root = document) => {
    const pages = root.matches && root.matches(pageSelector) ? [root] : Array.from(root.querySelectorAll(pageSelector));
    pages.forEach(disconnect);
  };

  const handleReady = () => init(document);
  const handleSectionLoad = (event) => init(event.target);
  const handleSectionUnload = (event) => cleanup(event.target);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', handleReady, { once: true });
  } else {
    handleReady();
  }

  document.addEventListener('shopify:section:load', handleSectionLoad);
  document.addEventListener('shopify:section:unload', handleSectionUnload);

  window.MioAboutMotion = {
    teardown() {
      document.removeEventListener('DOMContentLoaded', handleReady);
      document.removeEventListener('shopify:section:load', handleSectionLoad);
      document.removeEventListener('shopify:section:unload', handleSectionUnload);
      cleanup(document);
    },
  };
})();
